var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"how-it-works"},[(_vm.isLoggedIn)?_c('cmg-member-loyalty-rewards',{staticClass:"rewards"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }